import { ErrorType } from '@/__generated__/applyRefundMutation.graphql';
import { TAX_REFUND_ERROR } from '@/components/tax-refund/common/error/error';
import { CORPORATION_PATHS, INDIVIDUAL_PATHS } from '@/lib/constants/paths';
import { BusinessType } from '@/lib/types/request';

export function handleErrorCode(businessType: BusinessType, errorCode: ErrorType) {
  const isIndis = businessType === 'indis';
  switch (errorCode) {
    // 사업자가 아닌 개인 양도소득세 조회시에만 발생
    case TAX_REFUND_ERROR.홈택스사업자없음:
      return INDIVIDUAL_PATHS.개인신고내역없음;
    case TAX_REFUND_ERROR.홈택스타임아웃:
      return isIndis ? INDIVIDUAL_PATHS.개인홈택스수집지연 : CORPORATION_PATHS.법인홈택스수집지연;
    case TAX_REFUND_ERROR.홈택스이용불가시간:
      return isIndis ? INDIVIDUAL_PATHS.개인홈택스이용불가시간 : CORPORATION_PATHS.법인홈택스이용불가시간;
    case TAX_REFUND_ERROR.홈택스점검중:
      return isIndis ? INDIVIDUAL_PATHS.개인홈택스점검중 : CORPORATION_PATHS.법인홈택스점검중;
    case TAX_REFUND_ERROR.홈택스세션오류:
      return isIndis ? INDIVIDUAL_PATHS.개인재로그인유도 : CORPORATION_PATHS.법인재로그인유도;
    case TAX_REFUND_ERROR.홈택스기타오류:
      return isIndis ? INDIVIDUAL_PATHS.개인기타오류 : CORPORATION_PATHS.법인기타오류;
    case TAX_REFUND_ERROR.홈택스계산오류:
    case TAX_REFUND_ERROR.홈택스수집오류:
      return isIndis ? INDIVIDUAL_PATHS.개인일시적인오류 : CORPORATION_PATHS.법인일시적인오류;
    default:
      // 그 외 정의되지 않은 오류
      return isIndis ? INDIVIDUAL_PATHS.개인일시적인오류 : CORPORATION_PATHS.법인기타오류;
  }
}
